import showConfirm from "./showConfirm";
import { startLoading, stopLoading } from "./loading";
import { openNewTab } from "./openTab";
import { downloadFile } from "./downloadFile";

export default {
  methods: {
    showConfirm,
    stopLoading,
    startLoading,
    openNewTab,
    downloadFile
  }
};
